/* eslint-disable react/button-has-type */
/* eslint-disable no-shadow */
/* eslint-disable camelcase */
import React, {
  useContext, useEffect, useLayoutEffect
} from 'react'
import { Button } from '@telus/koodo-ui-kit'
import { useHistory } from 'react-router-dom'
import ConsumerActivationPaths from '@sites/consumer/activation/ConsumerActivationPaths'
import { logOut } from '@apps/redux/features/CommonSlice'
import ActivationErrorLayout from '@apps/flows/activation/sections/ActivationErrorLayout'
import {
  PRIMARY_CTA_TOKENS,
  PRIMARY_CTA_WRAPPER,
  SECONDARY_CTA_TOKENS,
  SECONDARY_CTA_WRAPPER
} from '@apps/flows/activation/sections/activationCtaTokens'
import { useLocation } from 'react-router'
import Sites from '@sites/index'
import { setPageAnalytics } from '@apps/utils/Analytics'
import { ANALYTICS_EVENT_TYPES } from '@apps/utils/constants'
import { APPLICATION_STATE, ApplicationContext } from '@apps/contexts/ApplicationContext'
import { useSelector, useDispatch } from 'react-redux'
import { getBySlug, getById, getImgByTitle } from '@apps/utils/contentful'
import useTagManagerInfo from '@/_engine/hooks/useTagManagerInfo'

const AlreadyActivated = () => {
  const { pageContent, featureFlags } = useSelector((state) => state.common.content)
  const { userType } = useSelector((state) => state.common)
  const ban = useSelector((state) => state?.common?.user?.accountInfo?.profile?.ban)
  const consumerActivationPaths = new ConsumerActivationPaths()
  const dispatch = useDispatch()

  const history = useHistory()
  const showSplashing = featureFlags?.[0]?.showSplashing

  useLayoutEffect(() => {
    if (showSplashing) {
      history.replace(consumerActivationPaths.Splash)
    }
  }, [showSplashing, history])

  if (showSplashing) {
    return null
  }

  const {
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.CURRENT_REGION]: region,
    [APPLICATION_STATE.SERVICES]: brandServices,
    [APPLICATION_STATE.IDENTITY]: identity
  } = useContext(ApplicationContext)

  const { retrieveCookie, deleteCookie } = brandServices

  const location = useLocation()
  const tagManagerInfo = useTagManagerInfo()

  const pushTagManagerToDataLayer = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(location, 'form', region, language, {
        ...tagManagerInfo,
        customer_ban: ban,
        promoCodeDescription: 'No Info available'
      })
    )
  }

  const pushClickAnalytics = (
    click_text,
    onComplete,
    event_type = ANALYTICS_EVENT_TYPES.CLICK,
  ) => {
    window.dataLayer = window.dataLayer || []
    if (!window.dataLayer) {
      onComplete?.()
      return
    }
    window.dataLayer.push({
      ...setPageAnalytics(location, 'click', region, language, {
        ...tagManagerInfo,
        click_text,
      }, event_type),

      eventCallback: onComplete,
      eventTimeout: 2000,
    })
  }

  useEffect(() => {
    if (userType === Sites.consumer) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
    }
  }, [region, language])

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action === 'pop' || action === 'POP') {
        return false
      }
      return () => {
        unblock()
      }
    })
  }, [history])

  const activatePage = getById(pageContent, 'activateAlreadyPageConsumer')[language]
  const pinata = getImgByTitle(activatePage, 'pinata-consumer')
  const selfServeLink = getById(pageContent, 'commonElements')[language]
  const selfServeRedirect = getBySlug(selfServeLink?.shortTextFields, 'self-serve-link')?.value
  const handleNextClick = async () => {
    pushClickAnalytics(
      getBySlug(activatePage?.shortTextFields, 'go-to-self-service-portal')?.value,
      () => {
        window.location = selfServeRedirect
      }
    )
  }


  const redirectToLandingPage = () => {
    window.location = consumerActivationPaths.Base
  }

  const handleLogout = async () => {
    pushClickAnalytics(getBySlug(activatePage?.shortTextFields, 'go-back-portal-consumer')?.value)
    const { userSessionId } = await retrieveCookie() || {}
    if (userSessionId) {
      await deleteCookie()
      dispatch(logOut())
      redirectToLandingPage()
    } else {
      dispatch(logOut())
      redirectToLandingPage()
    }
  }

  return (
    <ActivationErrorLayout
      imageUrl={pinata?.url}
      imageAlt={pinata?.altText || 'Colorful Piñata'}
      heading={getBySlug(activatePage?.shortTextFields, 'already-been-activated-consumer')?.value}
      body={getBySlug(activatePage?.shortTextFields, 'already-been-activated-body-consumer')?.value}
      variant="notice"
    >
      <div className={PRIMARY_CTA_WRAPPER}>
        <Button
          onPress={() => handleNextClick()}
          variant={{ width: 'full' }}
          tokens={PRIMARY_CTA_TOKENS}
          testId="plans-nextStep"
        >
          {getBySlug(activatePage?.shortTextFields, 'go-to-self-service-portal')?.value}
        </Button>
      </div>

      <div className={SECONDARY_CTA_WRAPPER}>
        <Button
          onPress={() => handleLogout()}
          variant={{ width: 'full' }}
          tokens={SECONDARY_CTA_TOKENS}
          testId="already-activated-other-email"
        >
          {getBySlug(activatePage?.shortTextFields, 'go-back-portal-consumer')?.value}
        </Button>
      </div>
    </ActivationErrorLayout>
  )
}

export default AlreadyActivated
